import 'css-chunk:src/index/pages/task_edit/index.module.scss';export default {
  "tablet": "tablet__n7Hia",
  "sp": "sp__hXGTB",
  "pc": "pc__wfI36",
  "pcTablet": "pcTablet__LF0H3",
  "section": "section__4fcN-",
  "relative": "relative__5P46q",
  "row": "row__LZzn1",
  "middle": "middle__-3hoA",
  "formLabel": "formLabel__if9Kr",
  "formLabel2": "formLabel2__6dPWN",
  "formLabelIssue": "formLabelIssue__P7IvB",
  "searchBox": "searchBox__h17-Q",
  "hide": "hide__fyy0P",
  "menuShowBtn": "menuShowBtn__2EYTV"
};